module.exports = __webpack_public_path__ + "img/yl_02.db3e5215.png";